export default "__VITE_ASSET__DyfaPZAa__"